import { useState, useEffect } from 'react'
import { debounce } from '../helpers'

export default function useResize(imageLoaded){
    const [collapseH, setCollapseH] = useState(0);

    useEffect(()=>{
        setCollapseH(document.getElementById("collapseId").clientHeight)
    }, [imageLoaded])

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
          setCollapseH(document.getElementById("collapseId").clientHeight)
        }, 1000)
        window.addEventListener('resize', debouncedHandleResize)
        return () => {
          window.removeEventListener('resize', debouncedHandleResize)
        }
    },[])
    
    return {
        collapseH,
    }
}